/**
 * API 配置
 * 統一管理所有 API 端點的基礎 URL 和路由路徑
 */

// API 基礎 URL - 從環境變數讀取，如果沒有則使用預設值
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://review-api.calllink.ai/api/store'

// API 端點
export const API_ENDPOINTS = {
    // 認證相關
    LOGIN: '/login',

    // 店家分析相關
    STORE_ANALYZE: '/analyze',

    // 評論相關
    COMMENTS: '/comments',
    REVIEWS_DETAILS: '/reviews/details',

    // AI 回覆生成（根據 API 文件：GET /api/store/replyContent）
    GENERATE_REPLY: '/replyContent',

    // 店家設定
    STORE_SETTINGS: '/create-and-run',

    // 分類關鍵字（搜尋功能）
    CATEGORY_KEYWORD: '/search',

    // 店家標記檢查
    STORE_FLAG: '/checkFlag',

    // 查詢分類或關鍵字
    QUERY_TYPE: '/queryType',

    // 生成評論回覆
    REPLY_COMMENTS: '/replyComments',

    // 下載評論列表 CSV
    COMMENTS_DOWNLOAD: '/comments/download'
} as const

// 前端路由路徑
export const ROUTES = {
    // 公開頁面
    LOGIN: '/login',
    STORE_SETTING: '/store-setting',
    WAITING: '/waiting',

    // 受保護頁面
    DASHBOARD: '/dashboard',
    REVIEW_CENTER: '/reviewcenter',
    COMMENT_FOOD: '/comment-food',
    DETAILS: '/details',
    CHAT_AI: '/chat-ai',
    CHAT_AI_CREATE: '/chat-ai-create',
    SETTING: '/setting',
    RECENT: '/recent'
} as const

/**
 * 建構完整的 API URL
 * @param endpoint API 端點
 * @returns 完整的 API URL
 */
export const buildApiUrl = (endpoint: string): string => {
    return `${API_BASE_URL}${endpoint}`
}

/**
 * 取得 API 基礎 URL
 * @returns API 基礎 URL
 */
export const getApiBaseUrl = (): string => {
    return API_BASE_URL
}
